import { Checkbox, Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { Grid, GridFieldSection, ListFieldSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import ids from 'Components/Worksheets/QestIds';
import { hasValue, valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import { useSelector } from 'react-redux';
import BsEmbeddedWaterContent from './EmbeddedWaterContent';

const qestIds = [ids.oversizeDetermination.BS_1377_2_Clause_11];

let MeasuredOversizeDeterminationWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const allSieves = useSelector(createWorksheetSelector!('AllSieves'), deepEquals);

  const noOversizeMaterial: boolean = useSelector(
    pipe(createWorksheetSelector!('NoOversizeMaterial'), valueOrDefault(false))
  );
  const anyWetMassRetained = useSelector(
    pipe(createWorksheetSelector!('Sieves'), (s) => s?.some((s: any) => hasValue(s.WetMassRetained)) ?? false)
  );
  const waterContentTestIsUnnecessary: boolean = useSelector(
    pipe(createWorksheetSelector!('WaterContentTestIsUnnecessary'), valueOrDefault(false))
  );

  const disableNoOversizeMaterial = !noOversizeMaterial && anyWetMassRetained;

  const getRowHeaders = () => {
    if (!allSieves) return [];
    return allSieves.map((s: any) => s.Caption);
  };

  const getGridData = () => {
    if (!allSieves) return [];
    return allSieves.map((sieveDef: any, index: any) => [
      <Field
        emph
        input={<WorksheetEquipmentDropdown />}
        equipmentType="sieve"
        name={`Sieves[${index}].Sieve`}
        queryParams={{ SieveSize: `${sieveDef?.Size.value} ${sieveDef?.Size.uom}` }}
      />,
      <Field input={<NumericInput />} name={`Sieves[${index}].WetMassRetained`} />,
      <Field input={<TextOutput />} name={`Sieves[${index}].WetMassPassing`} />,
      <Field input={<TextOutput />} name={`Sieves[${index}].CumulativeWetMassPassingPercent`} />,
      <Field input={<TextOutput />} name={`Sieves[${index}].CumulativeDryMassPassingPercent`} />,
      <Field input={<TextOutput />} name={`Sieves[${index}].CumulativeDryMassRetainedPercent`} />,
    ]);
  };

  return (
    <>
      <ListFieldSection>
        <Field input={<Checkbox />} name="NoOversizeMaterial" disabled={disableNoOversizeMaterial} />
      </ListFieldSection>

      {!noOversizeMaterial ? (
        <>
          <GridFieldSection name="Sieves">
            <Grid
              cornerHeader="Sieve Size"
              colHeaders={[
                'Sieve ID',
                'Cumulative Mass Retained (g)',
                'Wet Mass Passing (g)',
                'Cumulative Wet Mass Passing (%)',
                'Cumulative Dry Mass Passing (%)',
                'Cumulative Dry Mass Retained (%)',
              ]}
              colWidths={[200, 150, 150, 150, 150, 150]}
              rowHeaders={getRowHeaders()}
              rowHeaderWidth={80}
              data={getGridData()}
            />
          </GridFieldSection>
          {!waterContentTestIsUnnecessary && <BsEmbeddedWaterContent />}
        </>
      ) : (
        <ListFieldSection>
          <Field input={<TextOutput />} name={`Sieves[${0}].CumulativeDryMassRetainedPercent`} />
          <Field input={<TextOutput />} name={`Sieves[${1}].CumulativeDryMassRetainedPercent`} />
        </ListFieldSection>
      )}
    </>
  );
};

MeasuredOversizeDeterminationWorksheet = withInjectedProps(MeasuredOversizeDeterminationWorksheet);

MeasuredOversizeDeterminationWorksheet.qestIds = qestIds;

export default MeasuredOversizeDeterminationWorksheet;
export { MeasuredOversizeDeterminationWorksheet };
